import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'chemrobotics_main';

  ngOnInit() {
    // Ensure scrolling is enabled on page load (prevents stuck modals after refresh)
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';

    // Cleanup any loose backdrops
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      document.body.removeChild(backdrops[0]);
    }
  }
}
